module.exports = __webpack_public_path__ + "img/aashuai.3f615f2e.gif";